import { render } from "./TransferPerformanceView.vue?vue&type=template&id=0f8ded17"
import script from "./TransferPerformanceView.vue?vue&type=script&lang=js"
export * from "./TransferPerformanceView.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__